import React from 'react';
import TranslationProjectPreTranslate from '../components/TranslationProjectPreTranslate';

export type IProps = {
  courseId: number;
};

const TranslationProject: React.FC<IProps> = (props) => {
  return <TranslationProjectPreTranslate courseId={props.courseId} />;
};

export default TranslationProject;
